module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA8AAAAOCAYAAADwikbvAAAA60lEQVQokY3Qvy6DURgG8F+liYGhcQUuwfZdgcF1SEREDRKDoH38GcxoxA24AEttrN9mM9kZJAxiNWibT32l73aeN7/znJxGEtNMkezjuBItN6eEJ9gbi3dmpoALuMHn2OruT1wkZ3jCA1r4GKx6ZXI68dnF92e0B8cXLGIJq2WyC7W4SDroVqIW3tAcQvj17CI5xGHNndeYrwY/mouki04NvCyTjfFw1FwkR0gNPK+DI1wkKzio2ffKZKsOVpvXJzRuToLQ6DOLV8xV8osyaU8wo2libQDfcY9+mVz9B4f4Gdu4LZPHadBwvgCxAUCp9tn7IQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/xiugai.png
// module id = jVIz
// module chunks = 1